export default class AsdModals {

    static init() {

        window.asd_closeModal = AsdModals.close;
        window.asd_openModal = AsdModals.open;

    }

    static open(id) {
        var modal = document.getElementById(id + '_Modal');
        var a = document.getElementById(id + '_url');
        var url = a.href;
        var ifrm = document.createElement("iframe");
        ifrm.setAttribute("src", url);
        ifrm.setAttribute("id", id + '_iframe');
        modal.appendChild(ifrm);
        modal.removeChild(a);
        modal.addClass('open');
        modal.removeClass('closed');
    }

    static close(id, value, label) {
        var modal = document.getElementById(id + '_Modal');
        modal.removeClass('open');
        modal.addClass('closed');

        var input_id = document.getElementById(id + '_id');
        var input_label = document.getElementById(id + '_label');
        input_id.value = value;
        input_label.value = label;

        var iframe = document.getElementById(id + '_iframe');
        var a = document.createElement('a');
        a.id = id + '_url';
        a.href = iframe.src;
        modal.appendChild(a);
        modal.removeChild(iframe);
    }

}
